import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { PDFDownloadLink, StyleSheet } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import Invoice from './Invoice';
const styles = StyleSheet.create({
  container: {
    width: '200px',
    padding: '0px 12px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '15px',
    marginBottom: '12px',
    backgroundColor: 'red',
    color: '#FFFFFF',
    background: '#588AF0',
    boxShadow: '0px 15px 50px rgba(160,163,189,0.1)',
    height: '32px',

    fontSize: '12px',

    borderRadius: '4px',
    cursor: 'pointer',
  },
  flex: { display: 'flex', gap: '5px', alignItems: 'center', height: '100%' },
  bold: { fontSize: '13px', fontWeight: 600 },
  thin: { fontSize: '11px', color: '#6f6f6f', fontWeight: 500 },
  btn: {
    borderRadius: '3px',
    border: '1px solid gray',
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    padding: '3px',
    fontSize: '11px',
    color: '#4f4f4f',
    fontWeight: 600,
    cursor: 'pointer',
    userSelect: 'none',
  },
});
const PdfFile = ({ ticketData }) => {
  const { t } = useTranslation();
  return (
    <div style={styles.container}>
      <div style={{ ...styles.flex, ...{ justifyContent: 'space-between', color: '#fff' } }}>
        <PDFDownloadLink document={<Invoice ticketData={ticketData} />} fileName="invoice.pdf">
          <div style={{ display: 'flex', alignItems: 'center', color: '#fff' }}>
            <FileDownloadIcon />
            <span>{t('pages.services.flight.pages.btnDownload')}</span>
          </div>
        </PDFDownloadLink>
      </div>
    </div>
  );
};

export default PdfFile;
